export default __webpack_public_path__ + "static/media/redArrow2.df058075.webp";